import FileSize from "../../../../components/commonComponent/FileSize";
import React, { useState } from "react";
import { PdfPreviewModal } from "./PdfDocumentTable";
import transparencySummaryPdf from "../../../../assets/rti_pdf/tranAuditapdf-8a6518a9c3d6b3cc8bd40d407ae00d97.pdf";
import transparency2020Pdf from "../../../../assets/rti_pdf/tranAudita_2020_2021_pdf-8a6518a9c3d6b3cc8bd40d407ae00d97 (1).pdf";
import transparency2021Pdf from "../../../../assets/rti_pdf/TAReport2021_22PDF-7f115ee72f842377767c54a9d13bc802.pdf";
import transparency2022Pdf from "../../../../assets/rti_pdf/Transparency-Audit-ReportNMDFC-2022-23pdf-ded145b559805bb347745adb089d2f92.pdf";
import transparency2023Pdf from "../../../../assets/rti_pdf/SummaryReportNationalMinoritiesDevelopmentandFinanceCorporation2023-24pdf-9e9cf77f2755247f51e912ef403fa9a9.pdf";
import transparency2024Pdf from "../../../../assets/rti_pdf/SummaryReportNationalMinoritiesDevelopmentandFinanceCorporation2024-251pdf-c77f3f1fce14b87fb2f722d998fe3ba7.pdf";
import corporateSecretariatPdf from "../../../../assets/rti_pdf/Corporate-Secreteriatepdf-b31a60cb9488f87e62d1785322557876.pdf";
import manpowerSupplyPdf from "../../../../assets/rti_pdf/manpower-contractpdf-cc4219673f11abacc3a4b113cec8f18f.pdf";
import securityContractPdf from "../../../../assets/rti_pdf/Security-contractpdf-fdbf2ac27f499c2db035f0fd68586979.pdf";
import taxiContractPdf from "../../../../assets/rti_pdf/CMD-taxi-contractpdf-37ed077aa90b36ba151a209dee8a6f78.pdf";
import tourDetailsPdf from "../../../../assets/rti_pdf/Tour_A-DA-Details-of-CMDpdf-7e260dbe9854002bdf17b8a4c8d4acfd.pdf";
import brochureHindiPdf from "../../../../assets/rti_pdf/brochurehindi-FINApdf-f07c08fcd8ccd1a30cabde2372f1c10b.pdf";
import brochureEnglishPdf from "../../../../assets/rti_pdf/NMDFCBrochureEnglish-FINA4pdf-300e8786e726d4984b8b74c7e00e03c4.pdf";
import dpdpActPdf from "../../../../assets/rti_pdf/DPDPpdf-dc545c1d257d6bbde166be4b4c1e83b7.pdf";
import hindiBillTextPdf from "../../../../assets/rti_pdf/HindiBillText-DigitalPersonalDataProtectionBill2023pdf-a1f182071a160f081823e0dbd62702f9.pdf";
import rtiEnglishPdf from "../../../../assets/rti_pdf/RTIEnglishpdf-01d308b80efbcaaee8b045ede7e9ee6b.pdf";
import rtiHindiPdf from "../../../../assets/rti_pdf/RTIHindipdf-73d6591db2191174be992dcab3f64b4b.pdf";
import rtiLatestAmendmentsPdf from "../../../../assets/rti_pdf/RTIlatestupdarationpdf-e4bd624fcd002eb6ec0bf35f286cd327.pdf";
import rtiRulesHindiPdf from "../../../../assets/rti_pdf/RTIRules2019Hindipdf-fd3062d313bf157b32667756426a911a.pdf";

const transparencyReports = [
  {
    label: "Transparency Audit Report 2020-21:",
    title: "Transparency Audit Report 2020-21",
    fileName: "tranAudita_2020_2021_pdf-8a6518a9c3d6b3cc8bd40d407ae00d97 (1).pdf",
    href: transparency2020Pdf,
  },
  {
    label: "Transparency Audit Report 2021-22:",
    title: "Transparency Audit Report 2021-22",
    fileName: "TAReport2021_22PDF-7f115ee72f842377767c54a9d13bc802.pdf",
    href: transparency2021Pdf,
  },
  {
    label: "Transparency Audit Report 2022-23:",
    title: "Transparency Audit Report 2022-23",
    fileName: "Transparency-Audit-ReportNMDFC-2022-23pdf-ded145b559805bb347745adb089d2f92.pdf",
    href: transparency2022Pdf,
  },
  {
    label: "Transparency Audit Report 2023-24:",
    title: "Transparency Audit Report 2023-24",
    fileName:
      "SummaryReportNationalMinoritiesDevelopmentandFinanceCorporation2023-24pdf-9e9cf77f2755247f51e912ef403fa9a9.pdf",
    href: transparency2023Pdf,
  },
  {
    label: "Transparency Audit Report 2024-25:",
    title: "Transparency Audit Report 2024-25",
    fileName:
      "SummaryReportNationalMinoritiesDevelopmentandFinanceCorporation2024-251pdf-c77f3f1fce14b87fb2f722d998fe3ba7.pdf",
    href: transparency2024Pdf,
  },
];

const contractDocuments = [
  {
    serial: 2,
    label: "Corporate Secretariat:",
    title: "Corporate Secretariat",
    fileName: "Corporate-Secreteriatepdf-b31a60cb9488f87e62d1785322557876.pdf",
    href: corporateSecretariatPdf,
  },
  {
    serial: 3,
    label: "Manpower Supply:",
    title: "Manpower Supply",
    fileName: "manpower-contractpdf-cc4219673f11abacc3a4b113cec8f18f.pdf",
    href: manpowerSupplyPdf,
  },
  {
    serial: 4,
    label: "Security Contract:",
    title: "Security Contract",
    fileName: "Security-contractpdf-fdbf2ac27f499c2db035f0fd68586979.pdf",
    href: securityContractPdf,
  },
  {
    serial: 5,
    label: "Taxi Contract for Office or Ministry:",
    title: "Taxi Contract for Office or Ministry",
    fileName: "CMD-taxi-contractpdf-37ed077aa90b36ba151a209dee8a6f78.pdf",
    href: taxiContractPdf,
  },
  {
    serial: 6,
    label: "Taxi Contract for CMD:",
    title: "Taxi Contract for CMD",
    fileName: "CMD-taxi-contractpdf-37ed077aa90b36ba151a209dee8a6f78.pdf",
    href: taxiContractPdf,
  },
  {
    serial: 7,
    label: "Tour Details of JS and above:",
    title: "Tour Details of JS and above",
    fileName: "Tour_A-DA-Details-of-CMDpdf-7e260dbe9854002bdf17b8a4c8d4acfd.pdf",
    href: tourDetailsPdf,
  },
  {
    serial: 8,
    label: "Brochure Hindi:",
    title: "Brochure Hindi",
    fileName: "brochurehindi-FINApdf-f07c08fcd8ccd1a30cabde2372f1c10b.pdf",
    href: brochureHindiPdf,
  },
  {
    serial: 9,
    label: "Brochure English:",
    title: "Brochure English",
    fileName: "NMDFCBrochureEnglish-FINA4pdf-300e8786e726d4984b8b74c7e00e03c4.pdf",
    href: brochureEnglishPdf,
  },
  {
    serial: 10,
    label: "DPDP Act:",
    title: "DPDP Act",
    fileName: "DPDPpdf-dc545c1d257d6bbde166be4b4c1e83b7.pdf",
    href: dpdpActPdf,
  },
  {
    serial: 11,
    label: "Hindi Bill Text-Digital Personal Data Protection Bill 2023:",
    title: "Hindi Bill Text-Digital Personal Data Protection Bill 2023",
    fileName:
      "HindiBillText-DigitalPersonalDataProtectionBill2023pdf-a1f182071a160f081823e0dbd62702f9.pdf",
    href: hindiBillTextPdf,
  },
  {
    serial: 12,
    label: "RTI English:",
    title: "RTI English",
    fileName: "RTIEnglishpdf-01d308b80efbcaaee8b045ede7e9ee6b.pdf",
    href: rtiEnglishPdf,
  },
  {
    serial: 13,
    label: "RTI Hindi:",
    title: "RTI Hindi",
    fileName: "RTIHindipdf-73d6591db2191174be992dcab3f64b4b.pdf",
    href: rtiHindiPdf,
  },
  {
    serial: 14,
    label: "RTI Latest Amendments:",
    title: "RTI Latest Amendments",
    fileName: "RTIlatestupdarationpdf-e4bd624fcd002eb6ec0bf35f286cd327.pdf",
    href: rtiLatestAmendmentsPdf,
  },
  {
    serial: 15,
    label: "RTI Rules 2019 Hindi:",
    title: "RTI Rules 2019 Hindi",
    fileName: "RTIRules2019Hindipdf-fd3062d313bf157b32667756426a911a.pdf",
    href: rtiRulesHindiPdf,
  },
];

const transparencySummaryDocument = {
  title: "Transparency Audit Report Summary",
  fileName: "tranAuditapdf-8a6518a9c3d6b3cc8bd40d407ae00d97.pdf",
  href: transparencySummaryPdf,
};

const PdfBadge = () => (
  <span aria-hidden="true" className="relative inline-block h-7 w-6 shrink-0 rounded-[3px] bg-[#dfe5ea] align-middle shadow-[0_1px_2px_rgba(0,0,0,0.16)]">
    <span className="absolute right-0 top-0 h-0 w-0 border-b-[8px] border-l-[8px] border-b-[#c7d0d8] border-l-transparent" />
    <span className="absolute left-1/2 top-[13px] -translate-x-1/2 whitespace-nowrap rounded-[2px] bg-[#ff5145] px-[3px] py-[1px] text-[8px] font-bold leading-none text-white">
      PDF
    </span>
  </span>
);

const PdfOpenButton = ({ document, onOpen }) => (
  <button
    type="button"
    onClick={() => onOpen(document)}
    aria-label={`Open ${document.title}`}
    className="inline-flex flex-wrap items-center gap-2 bg-transparent p-0 text-[#123764] underline underline-offset-2 hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
  >
    Click here to open
    <PdfBadge /><FileSize href={document.href} fileName={document.fileName} />


  </button>
);

const ChapterEighteenContent = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  return (
    <>
      <article className="min-w-0 flex-1 px-1 pb-8 font-sans text-[14px] leading-7 text-[#123764]">
        <h2 className="mb-4 text-[20px] font-bold leading-7 text-[#006461]">
          Chapter 18 : Details of Contract
        </h2>

        <div className="overflow-x-auto rounded-lg border border-[#d9e4ef] bg-white">
          <table className="w-full min-w-[600px] border-collapse text-left text-[14px] leading-6">
            <caption className="sr-only">Chapter 18 contract documents and transparency audit reports</caption>
            <thead>
              <tr className="bg-[#dce9fb] text-[#123764]">
                <th scope="col" className="w-[72px] border-b border-[#d9e4ef] px-4 py-3">S.No.</th>
                <th scope="col" className="border-b border-[#d9e4ef] px-4 py-3">Title</th>
                <th scope="col" className="w-[260px] border-b border-[#d9e4ef] px-4 py-3">File</th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-[#fbfdff]">
                <td rowSpan={transparencyReports.length + 1} className="border-b border-r border-[#d9e4ef] px-4 py-3 align-top font-medium">1</td>
                <th scope="row" className="border-b border-[#d9e4ef] px-4 py-3 align-top font-semibold">{transparencySummaryDocument.title}</th>
                <td className="border-b border-[#d9e4ef] px-4 py-3 align-top">
                  <PdfOpenButton document={transparencySummaryDocument} onOpen={setSelectedDocument} />
                </td>
              </tr>
              {transparencyReports.map((document) => (
                <tr key={document.fileName} className="bg-[#fbfdff]">
                  <th scope="row" className="border-b border-[#d9e4ef] px-4 py-3 align-top font-normal">
                    <span className="flex items-start gap-3 pl-3">
                      <span aria-hidden="true">•</span>
                      <span>{document.title}</span>
                    </span>
                  </th>
                  <td className="border-b border-[#d9e4ef] px-4 py-3 align-top">
                    <PdfOpenButton document={document} onOpen={setSelectedDocument} />
                  </td>
                </tr>
              ))}
              {contractDocuments.map((document, index) => (
                <tr key={`${document.serial}-${document.fileName}`} className={index % 2 === 0 ? "bg-[#f5f9fc]" : "bg-[#fbfdff]"}>
                  <td className="border-b border-r border-[#d9e4ef] px-4 py-3 align-top font-medium">{document.serial}</td>
                  <th scope="row" className="border-b border-[#d9e4ef] px-4 py-3 align-top font-normal">{document.title}</th>
                  <td className="border-b border-[#d9e4ef] px-4 py-3 align-top">
                    <PdfOpenButton document={document} onOpen={setSelectedDocument} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </article>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={() => setSelectedDocument(null)}
        />
      )}
    </>
  );
};

export default ChapterEighteenContent;
